import config from '@config';
import merge from 'lodash/merge';

const fontFamily = 'FedraSansStd-medium';

const commonLangStyle = ({ lang, ...props }) => {
  const isIndian = config.indianLang.indexOf(lang) > -1;
  const styleObj = {
    title: {
      fontSize: { base: '20px', md: '18px' },
      fontFamily: isIndian ? config.momLangFont[lang] : 'Geist',
      lineHeight: 'normal',
      letterSpacing: '-0.28px',
      color: '#FFF',
    },
    stText: {
      fontSize: '16px',
      letterSpacing: '-0.16px',
      lineHeight: '24px',
      fontFamily: isIndian ? config.momLangFont[lang] : 'Geist',
      color: 'rgba(255, 255, 255, 0.70)',
    },
    privacyText: {
      fontSize: '14px',
      letterSpacing: '-0.14px',
      lineHeight: '20px',
      textTransform: 'uppercase',
      fontFamily: isIndian ? config.momLangFont[lang] : 'Geist',
      color: 'rgba(255, 255, 255, 0.70)',
    },
  };

  const finalObj = merge(styleObj, { ...props });
  return finalObj;
};

const FooterSt = {
  en: commonLangStyle({ lang: 'en' }),
  bn: commonLangStyle({ lang: 'bn' }),
  hi: commonLangStyle({
    lang: 'hi',
  }),
  te: commonLangStyle({ lang: 'te' }),
  kn: commonLangStyle({ lang: 'kn' }),
  gu: commonLangStyle({ lang: 'gu' }),
  mr: commonLangStyle({ lang: 'mr' }),
  ml: commonLangStyle({ lang: 'ml' }),
  'zh-tw': commonLangStyle({ lang: 'zh-tw' }),
  zh: commonLangStyle({ lang: 'zh' }),
  it: commonLangStyle({ lang: 'it' }),
  fr: commonLangStyle({ lang: 'fr' }),
  de: commonLangStyle({ lang: 'de' }),
  es: commonLangStyle({ lang: 'es' }),
  ru: commonLangStyle({ lang: 'ru' }),
  ta: commonLangStyle({ lang: 'ta' }),
  cn: commonLangStyle({ lang: 'cn' }),
  ar: commonLangStyle({
    lang: 'ar',
  }),
  id: commonLangStyle({ lang: 'id' }),
};
export default FooterSt;
